/** @format */

const template = `
<div
  ng-if="row.attainment"
  ng-click="onAttainmentClick({row: row})"
  ng-class="{'module': row.attainment.type === 'ModuleAttainment' ||  row.attainment.type === 'CustomModuleAttainment'}"
  class="row parent clickable">
  <div
    class="name-parent"
    ng-class="{'with-icon': row.attainments.length > 0, 'without-icon': !row.attainments || row.attainments.length == 0, 'col-4': showMenuButton, 'col-6': !showMenuButton}">
    <button
      type="button"
      class="non-button attainment-arrow"
      ng-if="row.attainments.length > 0"
      ng-click="toggle(); $event.stopPropagation()"
      aria-expanded="{{!row.hide}}"
      aria-label="{{row.name|localizedString}}, {{'ARIA_LABEL.SHOW_MODULES_ATTAINMENTS' | translate}}">
      <sis-icon icon="chevron" [icon-class]="row.hide ? null : 'cw-90'"></sis-icon>
    </button>
    <div class="name">
      <button ng-if="row.type === 'parent'" id="{{row.id + '-details-button'}}" class="non-button-inherit name" type="button">
        {{row.name|localizedString}}
        <span class="visually-hidden">{{'ARIA_LABEL.OPEN_ATTAINMENTS_INFO' | translate}}</span>
      </button>
      <span ng-if="row.type !== 'parent'">{{row.name|localizedString}}</span>
      <span ng-if="row.expired && !row.hasValidParentAttainment" class="tiny-badge secondary" translate="PROFILE.ATTAINMENT.EXPIRED"></span>
      <span ng-if="row.misregistration" class="tiny-badge danger" translate="PROFILE.ATTAINMENT.MISREGISTRATION"></span>
      <span ng-if="!row.primary" class="tiny-badge secondary" translate="PROFILE.ATTAINMENT.NOT_PRIMARY"></span>
      <span ng-if="row.isAboutToExpire && !row.hasValidParentAttainment" class="tiny-badge danger">
        <span translate="PROFILE.ATTAINMENT.EXPIRATION_IMMINENT"></span>
        {{row.attainment.expiryDate | localDateFormat}}
      </span>
      <span ng-if="attainmentsDisplayed === 'INVALID' && row.isValid"> ({{'PROFILE.ATTAINMENT.VALID_ATTAINMENT'|translate}}) </span>
      <span ng-if="row.code" class="code-parent">{{row.code}}</span>
    </div>
  </div>
  <div class="col-2 credit">
    <span
      ng-if="row.credits"
      translate="PROFILE.ATTAINMENT.CREDIT_AMOUNT"
      translate-value-credits="{{row.credits | decimalNumber}}"
      aria-label="{{'PROFILE.ATTAINMENT.CREDITS' | translate}} {{row.credits | decimalNumber}} {{'PROFILE.ATTAINMENT.POINTS' | translate}}">
    </span>
  </div>
  <div class="col-2 grade">
    <span aria-label="{{'PROFILE.ATTAINMENT.GRADE' | translate}} {{row.grade.abbreviation | localizedString}}"
      >{{row.grade.abbreviation | localizedString}}</span
    >
  </div>
  <div class="col-2 date">
    <span aria-label="{{'PROFILE.ATTAINMENT.DATE' | translate}} {{row.attainmentDate|date:'d.M.yyyy'}}"
      >{{row.attainmentDate|date:'d.M.yyyy'}}</span
    >
  </div>
  <div class="col-2 attainment-row-menu-button" ng-if="showMenuButton" ng-click="$event.stopPropagation()"
    ><sis-attainment-row-menu-button
      [attainment]="row.attainment"
      (attainment-edit-action-selected)="attainmentEditActionSelected({event: $event})"></sis-attainment-row-menu-button
  ></div>
</div>
<div ng-if="!row.attainment" class="row parent grouping-module">
  <div class="col-12 name-parent" ng-class="{'with-icon': row.attainments.length > 0}">
    <button
      type="button"
      class="non-button attainment-arrow"
      ng-if="row.attainments.length > 0"
      ng-click="toggle(); $event.stopPropagation()"
      aria-expanded="{{!row.hide}}"
      aria-label="{{row.name|localizedString}}, {{'ARIA_LABEL.SHOW_MODULES_ATTAINMENTS' | translate}}">
      <sis-icon icon="chevron" [icon-class]="row.hide ? null : 'cw-90'"></sis-icon>
    </button>
    <div class="name">{{row.name |localizedString}}</div>
  </div>
</div>
`;
export default template;
